<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :submit="handleSubmitFormEditCompanyUser"
        :rules="rulesForm"
        :title="$t('labels.editCompanyUser')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div
                class="p-4"
                :class="columnClass">
                <hts-form-radio
                    v-model="formData.registerBy"
                    label="Đăng ký bằng"
                    :items="registerByItems"
                    value-key="key"
                    label-key="label"
                    required />

                <hts-form-input
                    v-if="formData.registerBy === 'email'"
                    v-model="formData.email"
                    :required="true"
                    :label="$t('labels.emailRegister')"
                    :color="props.color"
                    name="emailRegister"
                    prop="emailRegister" />

                <hts-form-phone
                    v-if="formData.registerBy === 'phone'"
                    v-model="formData.phone"
                    :label="$t('labels.phoneRegister')"
                    autocomplete
                    required
                    name="phoneRegister"
                    prop="phoneRegister" />

                <hts-form-input
                    v-model="formData.fullName"
                    :required="true"
                    :label="$t('labels.fullName')"
                    :color="props.color"
                    name="fullName"
                    prop="fullName" />

                <div class="grid grid-cols-2 gap-4 mb-1">
                    <hts-form-select
                        v-model="formData.group"
                        :label="$t('labels.group')"
                        :items="listCompanyGroup"
                        key-id="_id"
                        key-label="name"
                        :color="props.color"
                        name="group"
                        prop="group"
                        required />
                    <hts-form-input
                        v-model="formData.jobTitle"
                        :label="$t('labels.jobTitle')"
                        :color="props.color"
                        name="jobTitle"
                        prop="jobTitle" />
                </div>
                <hts-form-input
                    v-model="formData.address"
                    :label="$t('labels.address')"
                    :color="props.color"
                    name="address"
                    prop="address" />
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import data from './imports/data'
import companyUserForm from './imports/form'
const { registerByItems } = data()

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: [String, Number],
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  companyUserIsSelectedToEdit: {
    type: Object,
    default: () => {}
  },
  listCompanyGroup: {
    type: Array<Object>,
    default: () => {}
  }
})
const emits = defineEmits(['close', 'refreshTables'])

const closeOverSide = () => {
  Object.assign(formData, { ...props.companyUserIsSelectedToEdit })
  formData.phone = {
    code: '+84',
    phone: '',
    countryCode: 'Vietnam +84'
  }
  emits('close')
}

const formData = reactive({ ...companyUserForm.initCompanyUser })

watch(props, () => {
  _init()
})

const _init = () => {
  Object.assign(formData, { ...props.companyUserIsSelectedToEdit })
  if (!formData.phone) {
    formData.phone = {
      code: '+84',
      phone: '',
      countryCode: 'Vietnam +84'
    }
  }
}
const undo = () => {
  _init()
}

const handleSubmitFormEditCompanyUser = () => {
  const api = {
    url: '/company/user/update',
    method: 'post'
  }

  const { id, registerBy, email, phone, fullName, address, jobTitle, group } = formData

  const body = {
    id: props.companyUserIsSelectedToEdit._id,
    registerBy,
    fullName,
    address,
    jobTitle,
    groupId: group
  } as { [key: string]: any }

  if (email) {
    body.email = email
  }

  if (phone && phone.phone) {
    body.phone = phone
  }

  $api(api, { body }).then((data: any) => {
    if (!data) {
      return true
    }
    const responseData: any = data.data.value
    if (!responseData) {
      return true
    }
    if (responseData.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.updateCompanyUserSuccess'))
      emits('close')
    }
  })
}

const rulesForm = computed(() => {
  const rules = {
    fullName: 'required',
    group: 'required'
  } as { [key: string]: any }

  if (formData.registerBy === 'email') {
    rules.emailRegister = 'required|email'
  } else {
    rules.phoneRegister = 'required'
  }

  return rules
})

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
